module.exports = __webpack_public_path__ + "img/icon-plus.2beb856d.svg";